import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconDashboard = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={20}
    fill="none"
    viewBox="0 0 24 20"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.6}
      d="M7.625 6.875c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25-.703 0-1.25-.547-1.25-1.25 0-.664.547-1.25 1.25-1.25ZM5.75 11.25c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25-.703 0-1.25-.547-1.25-1.25 0-.664.547-1.25 1.25-1.25ZM17 12.5c0-.664.547-1.25 1.25-1.25.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25-.703 0-1.25-.547-1.25-1.25ZM12 1.25c6.21 0 11.25 5.04 11.25 11.25 0 2.07-.586 4.023-1.523 5.664-.235.39-.665.625-1.094.625H3.328c-.43 0-.86-.234-1.055-.625C1.297 16.524.75 14.57.75 12.5.75 6.29 5.79 1.25 12 1.25Zm0 15.625c.86 0 1.563-.664 1.563-1.563 0-.859-.704-1.562-1.563-1.562-.898 0-1.563.703-1.563 1.563 0 .898.665 1.562 1.563 1.562Zm8.281 0a9.31 9.31 0 0 0 1.094-4.375c0-5.156-4.219-9.375-9.375-9.375-5.195 0-9.375 4.219-9.375 9.375 0 1.563.352 3.047 1.055 4.375h5.273c-.273-.469-.39-.977-.39-1.563A3.443 3.443 0 0 1 12 11.876c.273 0 .547.078.82.117l3.047-4.687a.986.986 0 0 1 1.328-.274c.43.313.547.86.274 1.328l-3.008 4.57c.586.626.976 1.485.976 2.383 0 .586-.156 1.094-.39 1.563h5.234ZM12 5c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25-.703 0-1.25-.547-1.25-1.25 0-.664.547-1.25 1.25-1.25Z"
    />
  </svg>
));
export default SvgIconDashboard;
